import FormBuilder from "./screens/FormBuilderScreen"
function App() {
  return (
    <FormBuilder />
  );
}

export default App;
